import { toPercentString } from '@aloft/toolkit-shared';

import { Tkv2OrderContext } from '../../../../controller/types.js';
import { AdjustmentRollups } from '../types.js';

export const makeRollupDictionary = (
  context: Tkv2OrderContext,
  compID: string,
): AdjustmentRollups => ({
  netAdjustment: {
    value: context.pairedCostResults.comps[compID]?.totals?.netAdjustment.toString(true),
    adjustment: context.pairedCostResults.comps[compID]?.totals?.netAdjustment,
  },
  netAdjustmentPct: {
    value: toPercentString(
      context.pairedCostResults.comps[compID]?.totals?.netAdjustmentPercentage ?? 0,
      1,
    ),
  },
  grossAdjustmentPct: {
    value: toPercentString(
      context.pairedCostResults.comps[compID]?.totals?.grossAdjustmentPercentage ?? 0,
      1,
    ),
  },
  adjustedSalePrice: {
    value: context.pairedCostResults.comps[compID]?.totals?.adjustedSalePrice.toString(true),
  },
});
